module.exports = __webpack_public_path__ + "img/arrow.9bd7d71d.png";